export default class ClubDiscount {
    static INDIVIDUAL_DISCOUNT = 'individual';

    static fromData(data) {
        const clubDiscount = new ClubDiscount();
        clubDiscount.id = data.id;
        clubDiscount.name = data.name;

        Object.seal(clubDiscount);
        return clubDiscount;
    }
}
